import styled from 'styled-components'

import { Section as SectionGS } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { media, colors, space, radii, borderWidths, zIndices } = theme

export const Section = styled(SectionGS)`
  background: #f3f6ff;
  padding-bottom: 0;

  @media (${media.desktop}) {
    padding-bottom: 7.5rem;

    h2,
    h2 > span {
      font-size: 3.5rem;
    }
  }
`

export const Card = styled.div`
  padding: ${space['spacing-sm']};
  border: ${borderWidths['border-stroke-micro']} solid ${colors['neutral-border-default']};
  border-radius: ${radii['corner-radius-md']};
  background-color: ${colors['neutral-background-default']};
  cursor: grab;
  height: 33rem;

  h3 {
    margin-bottom: ${space['spacing-md']};
  }

  @media (${media.desktop}) {
    height: 29rem;

    h3 {
      font-size: 1.188rem;
    }
  }
`

export const CardContent = styled.div`
  a {
    color: ${colors['neutral-text-weak']};

    &::after {
      border-bottom-color: ${colors['neutral-text-weak']};
    }
  }
`

export const RightSideWrapper = styled.div`
  position: relative;
  background: linear-gradient(0deg, rgb(0 34 75) 72%, rgb(255 255 255) 72%);
  margin: 0 -${space['spacing-md']};
  padding: 0 ${space['spacing-md']} ${space['spacing-xxxl']};

  @media (${media.desktop}) {
    background: none;
    padding-bottom: ${space['spacing-md']};
    margin: ${space['spacing-xxxl']} 0 0;
  }
`

export const CarouselWrapper = styled.div`
  overflow: hidden;

  > div:first-child {
    width: 20.5rem;
    overflow: unset;
  }

  .controls-wrapper {
    position: relative;
    z-index: ${zIndices[1]};
    margin-top: ${space['spacing-lg']};
    padding-right: ${space['spacing-md']};
  }

  @media (${media.desktop}) {
    > div:first-child {
      width: 24rem;
    }
  }
`

export const CarouselBg = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 30rem;
  background-color: ${colors['neutral-background-contrast']};

  @media (${media.desktop}) {
    border-radius: ${radii['corner-radius-md']};
    height: 25.5rem;
  }
`
